import React, { createContext } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { NotFoundPage } from "./pages/not-found-page";
import { LandingPage } from "./pages/landing-page/landing-page";
import { ActivateUserPage } from "./pages/activate-user-page/activate-user-page";
import { DeleteAccountPage } from "./pages/delete-account-page";
import { AvatarsPage } from "./pages/edit-profile/avatar-page";
import { QueryParamProvider } from "use-query-params";
import { TeachersPage } from "./pages/teachers-page/teachers-page";
import { TeacherDetailPage } from "./pages/teachers-detail-page/teacher-detail-page";
import { ForgotPasswordPage } from "./pages/pw-management-pages/forgot-password-page/forgot-password-page";
import { ResetPasswordPage } from "./pages/pw-management-pages/reset-password-page/reset-password-page";
import { ImprintPage } from "./pages/info-pages/ImprintPage";
import { AGBPage } from "./pages/info-pages/AGBPage";
import { HelpPage } from "./pages/info-pages/HelpPage/HelpPage";
import { ContactPage } from "./pages/info-pages/ContactPage";
import { ProtectedRoute } from "./components/common/ProtectedRoute";
import { HomePage } from "./pages/home-page/home-page";
import { useApolloClient, useQuery } from "@apollo/client";
import { GET_USER_HEADER } from "./apollo-client/queries";
import { showErrorToast } from "./toast/toast-service";
import { FormattedMessage } from "react-intl";
import { ProfilePage } from "./pages/profile-page/ProfilePage";

export const UserContext = createContext(null);

function Routes() {
  const client = useApolloClient();

  const { data: userData, error } = useQuery(GET_USER_HEADER, {
    skip: !localStorage.getItem("token"),
    onError: async (error) => {
      if (
        error.graphQLErrors?.some(
          (err) => err.message === "user not authenticated"
        )
      ) {
        await logout();
        return;
      }

      if (error.networkError) {
        showErrorToast(<FormattedMessage id={"general.error.network"} />);
      }
    },
  });

  const logout = async () => {
    localStorage.removeItem("token");
    window.location.replace("/"); // redirects without needing the router
    await client.resetStore();
  };

  return (
    <UserContext.Provider value={userData?.user}>
      <Router>
        <QueryParamProvider ReactRouterRoute={Route}>
          <Switch>
            <Route exact path="/">
              <LandingPage />
            </Route>
            <Route exact path="/registration">
              <LandingPage />
            </Route>
            <Route exact path={"/forgot-password"}>
              <LandingPage />
            </Route>
            <Route exact path={"/password-reset"}>
              <LandingPage />
            </Route>
            <Route exact path={"/delete-account"}>
              <DeleteAccountPage />
            </Route>
            <Route exact path="/activate-user">
              <ActivateUserPage />
            </Route>
            <Route exact path={"/forgot-password-old"}>
              <ForgotPasswordPage />
            </Route>
            <Route exact path={"/password-reset-old"}>
              <ResetPasswordPage />
            </Route>
            <Route exact path={"/imprint"}>
              <ImprintPage />
            </Route>
            <Route exact path={"/agb"}>
              <AGBPage />
            </Route>
            <Route exact path={"/help"}>
              <HelpPage />
            </Route>
            <Route exact path={"/contact"}>
              <ContactPage />
            </Route>

            <Route
              exact
              path="/courses/:id/teachers"
              component={TeachersPage}
            />
            <Route
              exact
              path="/courses/:id/teachers/:teachingId"
              component={TeacherDetailPage}
            />
            <ProtectedRoute path={"/home"} component={HomePage} />
            <ProtectedRoute
              path={"/profile/my-teachings"}
              component={ProfilePage}
            />
            <ProtectedRoute
              exact
              path={"/profile/my-content"}
              component={ProfilePage}
            />
            <ProtectedRoute
              exact
              path={"/profile/my-groups"}
              component={ProfilePage}
            />
            <ProtectedRoute exact path={"/profile"} component={ProfilePage} />
            <ProtectedRoute
              exact
              path={"/profile/edit"}
              component={ProfilePage}
            />
            <ProtectedRoute
              exact
              path={"/profile/edit/picture-change"}
              component={ProfilePage}
            />
            <ProtectedRoute
              exact
              path={"/profile/edit/change-pw"}
              component={ProfilePage}
            />
            <ProtectedRoute
              exact
              path={"/profile/help"}
              component={ProfilePage}
            />
            <Route
              exact
              path={"/profile/edit/add-photo"}
              component={AvatarsPage}
            />
            <Route exact path={"*"} component={NotFoundPage} />
          </Switch>
        </QueryParamProvider>
      </Router>
    </UserContext.Provider>
  );
}

export default Routes;
